<template>
  <div class="auth-wrapper">
    <img v-if="backgroundImage" :src="backgroundImage" class="auth-background-image" alt="">
    <div class="header-logo text-center">
      <router-link :to="{name:'Login'}" class="d-inline-block">
        <login-img/>
      </router-link>
    </div>
    <div class="auth-form-wrapper">
      <router-view/>
      <div class="support-wrapper">
        <span>{{ $t('label.contact_for_request') }}: </span>
        <a href="mailto:support@osol.fr">support@osol.fr</a>
      </div>
      <div class="language-switcher">
        <a-radio-group :default-value="defaultLanguage" button-style="solid" @change="switchLanguage">
          <a-radio-button value="en">English</a-radio-button>
          <a-radio-button value="fr">Français</a-radio-button>
        </a-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import LoginImg from '@/assets/text-logo.svg';

export default {
  components: {
    LoginImg
  },
  data: () => ({
    defaultLanguage: null
  }),
  computed: {
    backgroundImage() {
      const images = {
        Login: '/auth/login.png',
        ForgotPassword: '/auth/three-picos.png',
        ResetPassword: '/auth/three-picos.png',
        ChangePassword: '/auth/three-picos.png'
      };
      return images[this.$route.name] || null;
    }
  },
  beforeMount() {
    this.defaultLanguage = localStorage.getItem('language') || 'en';
  },
  methods: {
    switchLanguage(e) {
      localStorage.setItem('language', e.target.value);
      this.$root.$i18n.locale = e.target.value;
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-wrapper::v-deep {
  min-height: 100vh;
  background: #F7F8FA;
  position: relative;

  .auth-background-image {
    position: absolute;
    height: 75vh;
    right: 0;
    bottom: 0;
    z-index: 0;
    pointer-events: none;
  }

  .header-logo {
    padding: 40px 0 0;
    margin-bottom: 170px;
    text-align: center;

    a {
      position: absolute;
      left: calc(50% - 72px);
      z-index: 1;
    }
  }

  .auth-form-wrapper {
    margin: 0 200px;
    max-width: 410px;
    position: relative;
    z-index: 1;
    background: #fff;
    border-radius: 12px;
    padding: 40px;
    box-shadow: 0 4px 24px rgba(19, 37, 64, 0.08);

    .ant-input {
      background: #fff;
      border: 1px solid #D9E1EC;
      border-radius: 8px;
      transition: border-color 0.2s;

      &:hover {
        border-color: #467BFF;
      }

      &:focus {
        border-color: #467BFF;
        box-shadow: 0 0 0 2px rgba(70, 123, 255, 0.12);
      }
    }
  }

  .title {
    margin-bottom: 40px;
    font-size: 32px;
    white-space: nowrap;
  }

  .support-wrapper {
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid #E4EAF4;
    color: #6886A6;
    font-size: 13px;

    a {
      color: #467BFF;
      text-decoration: none;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .language-switcher {
    margin-top: 12px;

    .ant-radio-button-wrapper {
      height: auto;
      padding: 6px 14px;
      border: 1px solid #D9E1EC;
      font-size: 12px;
      line-height: 14px;
      color: #6886A6;
      background: transparent;
      transition: all 0.2s;

      &:first-child {
        border-radius: 6px 0 0 6px;
      }

      &:last-child {
        border-radius: 0 6px 6px 0;
      }

      &.ant-radio-button-wrapper-checked {
        background: #467BFF;
        border-color: #467BFF;
        color: #fff;
      }

      &:not(.ant-radio-button-wrapper-checked):hover {
        color: #467BFF;
        border-color: #467BFF;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@media (max-height: 820px) {
  .auth-wrapper::v-deep {
    .header-logo {
      padding: 40px 0 0;
      margin-bottom: 110px;
    }

    .auth-form-wrapper {
      margin: 0 120px;
      padding: 32px;

      .title {
        margin-bottom: 24px;
        font-size: 28px;
      }
    }
  }
}

@media (max-width: 765px) {
  .auth-wrapper::v-deep {
    .auth-background-image {
      display: none;
    }
  }

  .support-wrapper {
    background-color: #F7F8FA;
    border-radius: 12px;
    padding: 2px;
  }
}
</style>
